var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgApple = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "#fff",
  viewBox: "0 0 18.77 22.336"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.693 11.8a4.66 4.66 0 0 1 2.493-4.229 5.36 5.36 0 0 0-4.224-2.224c-1.77-.14-3.705 1.032-4.413 1.032-.748 0-2.463-.982-3.81-.982C2.957 5.445 0 7.62 0 12.043a12.4 12.4 0 0 0 .718 4.049c.638 1.83 2.942 6.318 5.346 6.243 1.257-.03 2.144-.893 3.78-.893 1.586 0 2.409.893 3.81.893 2.423-.035 4.508-4.114 5.116-5.949a4.94 4.94 0 0 1-3.077-4.586M12.87 3.615A4.7 4.7 0 0 0 14.067 0a5.3 5.3 0 0 0-3.386 1.74A4.77 4.77 0 0 0 9.4 5.326a4.19 4.19 0 0 0 3.47-1.711",
  className: "apple_svg__a"
})));
export default SvgApple;